import { useState, useEffect } from "react";
import axios from "axios";

export default function MembersList() {
    const [members, setMembers] = useState([]);

    useEffect(() => {
      const fetchMembers = async () => {
        try {
          const res = await axios.get("https://ja3dovqjxmtlhwe7ordy3ktkda0uontf.lambda-url.us-east-1.on.aws/members");
          console.log(res.data);
          setMembers(res.data);
        } catch (err) {
          console.error("Error fetching members:", err);
        }
      };
      fetchMembers();
    }, []);
    
    function formatDate(dateStr) {
      const date = new Date(dateStr);
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
      const yyyy = date.getFullYear();
    
      const hh = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const ss = String(date.getSeconds()).padStart(2, '0');
    
      return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`;
    } 


    return (
      <div className="space-y-4">
        {members.map((member) => (
          <div key={member.userId} className="p-4 my-2">
            <div className="bg-white p-6 rounded-xl shadow-md space-y-3 border border-gray-200">
              <div className="space-y-1 text-gray-800">
                <p><strong className="text-gray-600">👤 Name:</strong> {member.userName}</p>
                <p><strong className="text-gray-600">📧 Email:</strong> {member.email}</p>
                <p><strong className="text-gray-600">📞 Phone:</strong> {member.phone}</p>
                <p><strong className="text-gray-600">📅 Date of Joining:</strong> {formatDate(member.doj)}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  } 